const axios = require('axios').default;

import ROUTES from 'routes';
import * as Format from '@ohmsd/utils/formatters';
import { pathFromRoute } from '@ohmsd/utils';
import E from 'services/emitter';

import { AxiosResponse, AxiosPromise, AxiosRequestConfig, AxiosError } from 'axios';
export type ApiResponse<D> = AxiosResponse<D>;
export type ApiPromise<D> = AxiosPromise<D>;
export type ApiError<D> = AxiosError<D>;
export type ApiOpts = AxiosRequestConfig & {
  query?: object,
  params?: object,
  // route?: string,
  // url?: string | { route: string },
};

import { apifyPath, querifyUrl, isCancel } from './utils';
export { apifyPath, querifyUrl, isCancel };

export const ROOT = ROUTES.API.ROOT;

const api = axios.create({
  // baseURL: window.location.host === 'localhost:9000' // cypress
  //   ? `http://localhost:8080${ ROOT }`
  //   : ROOT,
  paramsSerializer: {
    serialize: function dummyParamsSerializer (v) { return '' },
  },
});

(window as any).$api = api;

export const APPADV_CTX_URLS = [
  ROUTES.API.CAMPAIGNS,
  ROUTES.API.AUDITORIES,
  ROUTES.API.CREATIVES,
  ROUTES.API.ADS_ACCOUNTS,
  ROUTES.API.DATA_SOURCES,
  // ROUTES.API.CONVERSIONS,
  ROUTES.API.SEGMENTS,
  ROUTES.API.CRTV_GROUPS,
  ROUTES.API.GOOGLE_OAUTH,
].map(route => pathFromRoute(route));

api.interceptors.request.use(
  (config: ApiOpts) => {
    config.url = getUrlFromConfig(config);
    // console.log('api/client', config);

    return config;
  }
);

export function getUrlFromConfig (config: ApiOpts) {
  const { $App } = window as any; // :(

  let { url } = config;
  if (!url)
    throw new Error('api/client: Empty URL!');

  const { params = {} } = config;

  url = pathFromRoute(url, params);

  let { query = {} } = config;
  // does URL belong to App/Adver context?
  if (APPADV_CTX_URLS.find(ctxUrl => url.startsWith(ctxUrl)))
    query = Object.assign({}, $App.ctxParams, query);

  url = querifyUrl(url, query);

  const root = window.location.host === 'localhost:9000' // cypress
    ? `http://localhost:8080${ ROOT }`
  : ROOT;

  return root + url;
}

api.interceptors.response.use(
  undefined,

  err => {
    const { $stats } = (window as any);
    if ($stats) {
      if (axios.isCancel(err))
        return err;

      const {
        config: { url, method, data: confData },
        response,
      } = err;

      if (response?.status === 401) {
        E.emit('Identity:401', response);
        return Promise.reject(new Error('Unauthorized'));
      }

      if (!navigator.onLine)
        return Promise.reject(new Error('You\'re offline.'));

      if (/api\/(user|auth)\//.test(url)) // TODO: rewrite api to not emit 400+
        return Promise.reject(err);

      const report = {
        type: 'AXIOS',
        time: Date.now() - $stats.start.time,
        config: { url, method, data: confData },
        response: null,
        message: null,
        stack: null,
      };

      if (response) {
        const { data, status, statusText } = response;
        report.response = { data, status, statusText };
      } else {
        report.message = err.message;
        report.stack = err.stack;
      }

      $stats.addError(report);
    }
    return Promise.reject(err);
  },
);

export const CancelToken = axios.CancelToken;

export default api;
